<template>
    <div class="repay">
        <Head :headInfo='headInfo' @onClickLeft='onBack' />
        <div class="total">
            <div class="line">
                <span>总差距<van-icon color="#999999" name="question-o" @click="onIcon" /></span>
                <span class="f40 colFF7A45">¥{{ shouldRebateData.totalLeftAmount | NumFormat }}</span>
            </div>
            <div class="line"><span>总应返</span><span>¥{{ shouldRebateData.totalShouldRebateAmount | NumFormat }}</span></div>
        </div>
        <van-list v-if="Object.keys(rebateList).length" v-model="loading" :finished="finished" :finished-text="finishText" :immediate-check="false" @load="onLoad">
            <div class="content" v-for="(item, index) in rebateList" :key="item.id">
                <div class="title"><img src="../../../assets/img/b2b/icon_home.png" />{{ index }}</div>
                <div class="list" v-for="it in item" :key="it.id">
                    <div class="head">
                        <h3>{{ it.rebateName }}</h3>
                        <div class="line"><span>返还方式</span><span>{{ it.returnWay === 1 ? '直接结算' : '抵扣货款' }}</span></div>
                        <!-- <div class="line"><span>计算范围</span><span>格力，美的</span></div> -->
                    </div>
                    <div class="bottom">
                        <div class="line"><span>满返类型</span><span>{{ ruleTypeList[it.ruleType - 1] }}</span></div>
                        <div class="line"><span>目标值</span><span>¥{{ it.targetAmount | NumFormat }}</span></div>
                        <div class="line"><span>实际值</span><span>¥{{ it.actualAmount | NumFormat }}</span></div>
                        <div class="line"><span>差距</span><span :class="{'colFF7A45': it.leftAmount}">¥{{ it.leftAmount | NumFormat }}</span></div>
                        <div class="line"><span>达成率</span><span :class="{'colFF7A45': parseInt(it.completePercent) < 100}">{{ it.completePercent }}</span></div>
                        <div class="line" v-if="it.rebatePercent"><span>满返比例</span><span>{{ it.rebatePercent }}</span></div>
                        <div class="line" v-if="it.staticAmount"><span>固定金额</span><span>¥{{ it.staticAmount | NumFormat }}</span></div>
                        <div class="line"><span>开始日期</span><span>{{ it.startDate }}</span></div>
                        <div class="line"><span>截止日期</span><span>{{ it.endDate }}</span></div>
                        <div class="line"><span>应返金额</span><span>¥{{ it.shouldRebateAmount |NumFormat }}</span></div>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
</template>
<script>
import { Toast, Dialog } from 'vant'
import Head from '../../common/head'
import { shouldRebate, shouldRebatePage } from '../api/api'
export default {
    name: 'repayDetail',
    components: {
        Head
    },
    data () {
        return {
            headInfo: {
                title: '应返明细'
            },
            userInfo: {},
            shouldRebateData: {},
            rebateListCopy: [],
            rebateList: {},
            showPopover: true,
            ruleTypeList: ['月返', '季返', '年返', '其他'],
            finishText: '数据已加载完毕',
            loading: false,
            finished: false,
            form: {
                pageNumber: 1,
                pageSize: 5
            }
        }
    },
    methods: {
        onBack () {
            this.$router.back()
        },
        onLoad () {
            this.form.pageNumber += 1
            this.getShouldRebatePage()
        },
        async getShouldRebate () {
            const { data } = await shouldRebate({
                memberCode: this.userInfo.companyCode
            })
            this.shouldRebateData = data
        },
        onIcon () {
            Dialog.alert({
                title: '提示',
                message: '会员所有满返差距加总',
                confirmButtonColor: '#FF7A45'
            }).then(() => {
                // on close
            })
        },
        async getShouldRebatePage () {
            Toast.loading({
                message: '加载中...',
                duration: 0,
                forbidClick: true
            })
            const { data } = await shouldRebatePage({
                ...this.form,
                memberCode: this.userInfo.companyCode
            })
            this.rebateListCopy = this.rebateListCopy.concat(data.records)
            let rebateData = this.rebateListCopy.reduce((acc, cur) => {
                if (!acc[cur.merchantName]) {
                    acc[cur.merchantName] = []
                }
                acc[cur.merchantName].push(cur)
                return acc
            }, {})
            Toast.clear()
            this.rebateList = rebateData
            this.loading = false
            if (this.rebateListCopy.length >= data.total) {
                this.finished = true
            }
            if (data.total < this.form.pageSize) {
                this.finishText = ''
            }
            this.$forceUpdate()
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.getShouldRebatePage()
        this.getShouldRebate()
    }
}
</script>
<style lang="scss" scoped>
.repay {
    .total {
        padding: 32px;
        background: #fff;
        font-size: 28px;
        color: #000;
        margin-bottom: 12px;
        .line {
            &:not(:last-child) {
                margin-bottom: 32px;
            }
            span:first-child {
                display: flex;
                align-items: center;
            }
        }
    }
    .content {
        background: #fff;
        margin-bottom: 20px;
        .title {
            font-size: 28px;
            color: #000;
            padding: 32px;
            border-bottom: 1px solid #ededf0;
            position: relative;
            display: flex;
            align-items: center;
            img {
                width: 40px;
                height: 40px;
                margin-right: 24px;
            }
        }
        .list {
            padding: 32px;
            &:not(:last-child) {
                border-bottom: 1px solid #ededf0;
            }
            .head {
                padding-bottom: 32px;
                border-bottom: 1px solid #ededf0;
                h3 {
                    font-size: 32px;
                    color: #000;
                }
                .line {
                    margin-top: 16px;
                    font-size: 28px;
                    color: #666;
                }
            }
            .bottom {
                padding: 32px 0 0;
                .line {
                    font-size: 28px;
                    color: #999;
                    &:not(:last-child) {
                        margin-bottom: 16px;
                    }
                }
            }
        }
    }
    .line {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}
/deep/ .van-icon {
    font-size: 30px;
    margin-left: 6px;
}
</style>